<template>
    <div class="table-responsive">
    <table class="table table-hover no-overflow">
        <thead>
            <tr>
                <th @click="sortBy('referenceNumber')">
                    Folio de Calificaciones
                    <span v-if="sortKey === 'referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.referenceNumber')">
                    Folio de Solicitudes
                    <span v-if="sortKey === 'loanApplication.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.referenceNumber')">
                    Folio de prospectos
                    <span v-if="sortKey === 'loanApplication.prospectus.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.branchOffice.name')">
                    Matriz y/o Sucursales
                    <span v-if="sortKey === 'loanApplication.prospectus.branchOffice.name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('personType.name')">
                    Tipo de persona
                    <span v-if="sortKey === 'personType.name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('score')">
                    Calificación
                    <span v-if="sortKey === 'score'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in sortedData" :key="item.id" v-if="sortedData.length != 0">
                <td class="sorting_1 dtr-control"> {{ item.referenceNumber }}</td>
                <td>{{ item.loanApplication.referenceNumber}}</td>
                <td>{{ item.loanApplication.prospectus.referenceNumber}}</td>
                <td>{{ item.loanApplication.prospectus.branchOffice.name }}</td>
                <td>{{ item.personType.name }}</td>
                <td>{{ this.$filters.formatPercent2(item.score) }}</td>
                <td>
                    <PrimaryButton class="btn-success" data-toggle="modal" :data-target="dataTarget"
                        @click.prevent="editItem(item)"><i class="fa fa-edit"></i>
                    </PrimaryButton>
                </td>
            </tr>
            <tr v-else>
                <td colspan="7" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
            </tr>
        </tbody>
    </table>
    </div>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';

export default {
    components: { PrimaryButton },
    data() {
        return {
            sortKey: '',
            sortOrder: 1, // 1 for ascending, -1 for descending
        }
    },
    emits: ['click-on-edit-btn'],
    props: {
        list: {
            type: Array,
            default: () => { },
            required: true
        },
        dataTarget: {
            type: String,
            default: '#modal-lg'
        },
        itemsPerPage: {
            type: Number,
            default: () => 10,
        },
        currentPage: {
            type: Number,
            default: () => 1
        }
    },
    computed: {
        getItem() {
            return this.list;
        },
        sortedData() {
            let sortedList = [...this.list];
            if (this.sortKey) {
                sortedList.sort((a, b) => {

                    let aValue = this.getNestedValue(a, this.sortKey);
                    let bValue = this.getNestedValue(b, this.sortKey);


                    if (aValue < bValue) return -1 * this.sortOrder;
                    if (aValue > bValue) return 1 * this.sortOrder;
                    return 0;
                });
            }
            return this.paginate(sortedList);
        }
    },
    methods: {
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1; // Toggle the sort order
            } else {
                this.sortOrder = 1; // Reset to ascending if a new column is sorted
            }
            this.sortKey = key;
        },
        getNestedValue(obj, key) {
            return key.split('.').reduce((o, i) => o[i], obj);
        },
        paginate(list) {
            if (!list || list.length === 0) return [];
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            return list.slice(start, start + this.itemsPerPage);
        },
        editItem(item) {
            this.$emit('click-on-edit-btn', item);
        },
    }
}
</script>